import React from 'react'
import styles from './EnterpriseFooter.module.scss'
import { Button } from 'spa/member/components/v2/Button'
import { useIsMobile } from 'spa/member/hooks/v2/useIsMobile'

export const StyledEnterpriseFooter: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <footer className={`flex flex-wrap justify-center items-center gap-M text-S text-member-gray-0 py-2XL tablet:gap-XL tablet:text-M tablet:py-4XL desktop:px-5XL ${styles.enterpriseFooter}`}>
      <div>ハイスキルなフリーランスをお探しの企業の方</div>
      <a href="https://agent.crowdworks.jp">
        <Button kind="outline" buttonType={isMobile ? 'SMALL' : 'DEFAULT'} link>企業向けサイトをみる</Button>
      </a>
    </footer>
  )
}
